import {
  PageLayoutBreadcrumb,
  PageLayoutHeader,
  PageLayoutSubtitle,
  PageLayoutTitle,
  PageLayoutTop,
} from '@/shared/components/page-layout';
import { MENU_LABEL, useMenuLabels } from '@/shared/i18n';
import { useParams } from '@/shared/modern-router';

import { useTranslation } from './hooks';

const HeaderDashboard = () => {
  const { t } = useTranslation();
  const { menuLabel } = useMenuLabels();
  const { processId } = useParams<{ processId: string }>();

  const breadcrumbs = [
    {
      text: menuLabel(MENU_LABEL.performance, t('performance')),
      href: `/org/[slug]/talent/panel/employee/performance/pid/${processId}/`,
    },
    {
      text: menuLabel(MENU_LABEL.pid, t('PID')),
    },
  ];

  return (
    <PageLayoutTop>
      <PageLayoutBreadcrumb items={breadcrumbs} />
      <PageLayoutHeader>
        <PageLayoutTitle title={menuLabel(MENU_LABEL.pid, t('PID_TITLE'))} />
        <PageLayoutSubtitle>{t('PID_DESCRIPTION')}</PageLayoutSubtitle>
      </PageLayoutHeader>
    </PageLayoutTop>
  );
};

export default HeaderDashboard;
